// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1SBhn","balanceDisclaimer":"posDashboard_balanceDisclaimer__3kX5I"};